import { httpDelete, httpGet, httpPut } from '@pressreader/services';

import type { CollectionWithIdDto, WithCollectionsDto } from '../types';

import { disableRetryParam, jsonBodyParam, pagesetsApiEndpointBaseUrl } from './constants';

function getPageSetCollectionsPath(pageSetId: string): string {
    return `${pageSetId}/collections`;
}

function getPageSetCollectionsData(pageSetId: string): Promise<WithCollectionsDto> {
    return httpGet(pagesetsApiEndpointBaseUrl, getPageSetCollectionsPath(pageSetId));
}

function upsertPageSetCollectionsData(
    pageSetId: string,
    data: {
        collections: CollectionWithIdDto[];
    },
): Promise<void> {
    return httpPut(pagesetsApiEndpointBaseUrl, getPageSetCollectionsPath(pageSetId), data, jsonBodyParam);
}

function removePageSetFromCollections(pageSetId: string) {
    return httpDelete(pagesetsApiEndpointBaseUrl, getPageSetCollectionsPath(pageSetId), disableRetryParam);
}

export { getPageSetCollectionsData, removePageSetFromCollections, upsertPageSetCollectionsData };
